<template>
  <div class="u-bg--sand u-height-1"><router-view /></div>
</template>

<script>
/* istanbul ignore file */
export default {
  name: 'App',
  metaInfo: {
    titleTemplate: titleChunk => (titleChunk ? `${titleChunk} | BukaReksa` : 'BukaReksa'),
  },
};
</script>
